import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { Vt, type Task } from "@relais/shared";
import { useOffline } from "../../lib/offline-context.js";
import { useSession } from "../../lib/auth.js";
import { VtEditProvider } from "../../features/vt-visite/VtEditProvider.js";
import { RenderLockedNotice } from "../../features/task-detail/RenderLockedNotice.js";

export const Route = createFileRoute("/tasks/$taskId/render/vt")({
  beforeLoad: ({ params, location }) => {
    // Bare /vt redirects to first step.
    const expectedPrefix = `/tasks/${params.taskId}/render/vt`;
    if (
      location.pathname === expectedPrefix ||
      location.pathname === `${expectedPrefix}/`
    ) {
      const first = Vt.VT_STEPS[0];
      throw redirect({
        to: "/tasks/$taskId/render/vt/$section/$subsection",
        params: {
          taskId: params.taskId,
          section: first.section,
          subsection: first.subsection,
        },
        replace: true,
      });
    }
  },
  component: VtRoot,
});

function VtRoot() {
  const { taskId } = Route.useParams();
  const { service } = useOffline();
  const session = useSession();
  const [task, setTask] = useState<Task | null>(null);

  useEffect(() => {
    if (!service) return;
    let cancelled = false;
    service.getTask(taskId).then((t) => {
      if (!cancelled) setTask(t);
    });
    return () => {
      cancelled = true;
    };
  }, [service, taskId]);

  if (session.status !== "authed") return <p className="text-sm text-muted-foreground">…</p>;
  if (!task) return <p className="text-sm text-muted-foreground">…</p>;
  if (task.type !== "vt") {
    return (
      <p className="text-sm text-destructive">
        Cette tâche n'est pas une visite technique.
      </p>
    );
  }
  if (
    task.status === "completed" ||
    task.status === "cancelled" ||
    task.status === "refused"
  ) {
    return <RenderLockedNotice task={task} />;
  }

  return (
    <VtEditProvider task={task} userId={session.session.user.id}>
      <Outlet />
    </VtEditProvider>
  );
}
